// Drop-in floating Preview button that uses your existing .btn styles
// - No custom colors: it inherits your .btn look & hover
// - Only positions the button fixed at bottom-right
// - Works across all breakpoints
//
// Usage:
//   1) Import and place <PreviewFab onClick={() => setShowPreview(true)} /> once near your form root.
//   2) Remove previous custom .preview-fab button.
//
// Optional props:
//   label?: string (default 'Прев’ю')
//   title?: string (aria-label/tooltip)
//   className?: string (extra classes to merge with 'btn')

import React from 'react';

export function PreviewFab({ onClick, label = 'Прев’ю', title = 'Відкрити прев’ю', className = '' }) {
    return (
        <>
            <style>{`
        .preview-fab-wrap { position: fixed; right: 16px; bottom: 16px; z-index: 100; }
        /* keep spacing from iOS home indicator */
        @supports (bottom: env(safe-area-inset-bottom)) {
          .preview-fab-wrap { bottom: calc(16px + env(safe-area-inset-bottom)); right: calc(16px + env(safe-area-inset-right)); }
        }
        /* optional: hide when printing */
        @media print { .preview-fab-wrap { display: none; } }
        /* compact icon + label spacing */
        .btn .icon-left { display:inline-flex; margin-right:8px; }
      `}</style>
            <div className="preview-fab-wrap submit-block">
                <button style={{width: '8rem', borderRadius: '1rem', height: '2.5rem'}} type="button" className={`btn ${className}`} onClick={onClick} title={title} aria-label={title}>
          <span className="icon-left" aria-hidden>
            <svg style={{alignSelf: "center"}} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
          </span>
                    {label}
                </button>
            </div>
        </>
    );
}
